import {
  DEFAULT_DOCUMENT_TYPE,
  TRANSCRIPTOR_V2_DOCUMENT_TYPES,
  WIRE_DOCUMENT_TYPE_ALIASES,
} from '../config/constants';
import { DocumentType } from '../config/types';

export const parseDocumentType = (
  type?: DocumentType | string | null,
): DocumentType | undefined => {
  if (!type) {
    return undefined;
  }

  if (TRANSCRIPTOR_V2_DOCUMENT_TYPES.includes(type as DocumentType)) {
    return type as DocumentType;
  }

  return WIRE_DOCUMENT_TYPE_ALIASES[type.toLowerCase()];
};

export const normalizeDocumentType = (
  type?: DocumentType | string | null,
): DocumentType => parseDocumentType(type) ?? DEFAULT_DOCUMENT_TYPE;
